import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { MetaDrivenTable, PaginationControls, SearchField, StatusChip } from "../../../shared/components";
import {
    FilterList as FilterListIcon,
} from "@mui/icons-material";
import { formatCurrency } from "../../../shared/utils";
import { useVariations } from "../hooks/useVariations";

export const Variations: React.FC<{ projectId: string | undefined }> = ({ projectId }) => {

    const {
        isLoading, isError, error, data, pagination,
        changePage, changeRowsPerPage,
        searchDraft, handleChangeSearch, handleClear, handleSearch
    } = useVariations(projectId);

    const headers = [
        { "alias_name": "variation_id", "label": "Variation ID", "is_editiable": false, "domain": "", "display_order": 1, "is_show": false, "is_export": null },
        { "alias_name": "variation_details", "label": "Variation Details", "is_editiable": false, "domain": "", "display_order": 2, "is_show": true, "is_export": null },
        { "alias_name": "category", "label": "Category", "is_editiable": false, "domain": "", "display_order": 3, "is_show": true, "is_export": null },
        { "alias_name": "time_changes", "label": "Time Changes", "is_editiable": false, "domain": "", "display_order": 4, "is_show": true, "is_export": null },
        { "alias_name": "contract_ref", "label": "Contract", "is_editiable": false, "domain": "", "display_order": 5, "is_show": true, "is_export": null },
        { "alias_name": "budget_ref", "label": "Budget ID", "is_editiable": false, "domain": "", "display_order": 6, "is_show": false, "is_export": null },
        { "alias_name": "supplier", "label": "Contract & Supplier", "is_editiable": false, "domain": "", "display_order": 7, "is_show": true, "is_export": null },
        { "alias_name": "variance_amount", "label": "Variance Amount", "is_editiable": false, "domain": "", "display_order": 8, "is_show": true, "is_export": null },
        { "alias_name": "status", "label": "Status", "is_editiable": false, "domain": "", "display_order": 9, "is_show": true, "is_export": null },
    ];

    const metrics = {
        "status": {
            type: "component",
            element: (row: { status: string }) => (
                <StatusChip label={row.status} color={
                    row.status === 'Raised' ? 'amber' : row.status === 'Approved' ? 'green' : row.status === 'Under Review' ? 'red' : 'default'
                } />
            )
        },
        "variance_amount": {
            type: "component",
            element: (row: { variance_amount: string }) => formatCurrency(Number(row.variance_amount))
        }
    };

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <Box display="flex" gap={2} px={2}>
                <SearchField searchTerm={searchDraft} handleSearch={handleChangeSearch} handleClearSearch={handleClear} handleApplySearch={handleSearch} />
                <Button sx={{ color: "text.primary" }} startIcon={<FilterListIcon />}>
                    Filters
                </Button>
            </Box>
            <Box flex={1} sx={{ overflowX: "hidden", overflowY: "auto" }}>
                <MetaDrivenTable headers={headers} data={data} dataMetrics={metrics} sortDisabled={true} />
            </Box>
            <Box flexShrink={0}>
                <PaginationControls
                    total={pagination?.total}
                    rowsPerPage={pagination?.limit}
                    currentPage={pagination?.page}
                    handleRowsPerPage={changeRowsPerPage}
                    handlePageChange={changePage}
                />
            </Box>
        </Box>
    );

};